import React from 'react';
import Dashboard from './Dashboard';

const IeemDashboard = () => <Dashboard />;

export default IeemDashboard;
